import {Injectable} from '@angular/core';
import {Preferences as Storage} from '@capacitor/preferences'

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() {
  }

  async getItem(key: string): Promise<any> {
    let val:any = (await Storage.get({key})).value;
    if (val == '') return null;
    try {
      if (typeof JSON.parse(val) == 'object') return JSON.parse(val);
    } catch {

    }
    return val;
  }

  async setItem(key: string, value: any): Promise<void> {
    if (!value) {
      return await Storage.set({key, value: ''});
    }
    if (typeof value == 'string') {
      return await Storage.set({key, value});
    }
    if (typeof value == 'object')
      value = JSON.stringify(value);
    else value = value.toString()
    return await Storage.set({key, value});
  }

  remove(key: string): Promise<void> {
    return Storage.remove({key});
  }
}
